import moment from "moment";

const trancateTime = (date: Date): Date => {
  return moment.utc(moment(date).format("YYYY-MM-DD")).toDate();
};

const isAfter = (firstDate: Date, secondDate: Date): boolean => {
  var firstOnlyDate = moment(moment(firstDate).format("LL"));
  var secondOnlyDate = moment(moment(secondDate).format("LL"));
  const result = firstOnlyDate.isAfter(secondOnlyDate, "day");
  return result;
};

const isBetween = (dateToCheck: Date, startDate: Date, endDate: Date): boolean => {
  var dateOnlyToCheck = moment(moment(dateToCheck).format("LL"));
  var startOnlyDate = moment(moment(startDate).format("LL"));
  var endOnlyDate = moment(moment(endDate).format("LL"));
  const result = dateOnlyToCheck.isBetween(startOnlyDate, endOnlyDate, "day", "[]");
  return result;
};

const formatFieldValue = (field: any, fv: any): string | null | undefined => {
  if (!fv) return undefined;
  if (field?.fieldType === "Date" && fv.dateValue) {
    const fmt = field.includeTime ? "L HH:mm" : "L";
    return moment.utc(fv.dateValue).local().format(fmt);
  }
  return fv.displayValue;
};

const toLocalDateTimeString = (date: Date | string): string => {
  return moment.utc(date).local().format("DD/MM/YYYY HH:mm");
};

export { trancateTime, isAfter, isBetween, formatFieldValue, toLocalDateTimeString };
